import { Report } from 'src/api'
import { ReportTypeNameEnum } from 'src/enums'

export const REPORT_IN_PROGRESS_STATUS = 'in_progress'

export interface SubreportOption {
  id: number
  label: string
}

export const isCombinedReport = (report?: Report | null): boolean => report?.type?.name === ReportTypeNameEnum.CombinedReport

export const isReportInProgress = (report?: Report | null): boolean => report?.status === REPORT_IN_PROGRESS_STATUS

export const getSubreportOptions = (report?: Report | null): SubreportOption[] =>
  (report?.subreports || [])
    .filter((subreport) => typeof subreport.id === 'number')
    .map((subreport) => ({
      id: subreport.id as number,
      label: subreport.project?.name || `Subreport #${subreport.id}`
    }))
